import { Grid, TextField, Typography, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProcessStep } from '../../common/enums/enums';
import { isEmpty } from '../../helpers/numbers';

const StyledGrid = styled(Grid)(() => ({
  display: 'flex',
  gap: '5px',
}));

const StyledSignedGrid = styled(Grid)(() => ({
  display: 'flex',
  gap: '20px',
}));

const StyledSignedGridDone = styled(Grid)(() => ({
  display: 'flex',
  gap: '20px',
  justifyContent: 'end',
}));

const StyledGridItem = styled(Grid)(({ theme }) => ({
  display: 'flex',
  gap: '20px',
  alignItems: 'flex-end',
  [theme.breakpoints.down('sm')]: {
    alignItems: 'flex-start',
    marginBottom: '10px',
  },
}));

const StyledColumnGrid = styled(Grid)(() => ({
  display: 'flex',
  gap: '5px',
  flexDirection: 'column',
}));

const DateContainer = styled(Grid)(() => ({
  display: 'flex',
  gap: '20px',
}));

const StyledTitles = styled(Typography)(() => ({
  color: '#00000099',
}));

const StyledDiv = styled('div')(({ theme }) => ({
  backgroundColor: '#F3F3F3',
  [theme.breakpoints.down('sm')]: {
    width: '200px',
  },
  width: '260px',
  height: '77px',
}));

const StyledImg = styled('img')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    width: '200px',
  },
  width: '260px',
  height: '77px',
}));

const StyledDivImg = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    width: '200px',
  },
  width: '260px',
  height: '77px',
}));

const StyledTextField = styled(TextField)(() => ({
  pointerEvents: 'none',
  '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
    borderColor: '#bdbdbd',
  },
}));

const WOSignOffManager = ({ isManager = false, isVendor, handleSignIn }) => {
  const { t } = useTranslation('global');
  return (
    <>
      <Grid item>
        <Button
          size="medium"
          variant="contained"
          onClick={() => handleSignIn()}
          disabled={!!isVendor}
        >
          {t('signOff.approveSignIn')}
        </Button>
      </Grid>
    </>
  );
};

export const WOSignoffGrid = ({
  title = '',
  name = '',
  notes = '',
  signature = '',
  date = '',
  isManager,
  handleSignIn,
  step,
}) => {
  const { t } = useTranslation('global');
  return (
    <StyledColumnGrid>
      <Grid container spacing={2}>
        <Grid container item xs={12} lg={6} direction="column">
          <Typography sx={{ marginBottom: '10px' }} color="#000">
            {title}
          </Typography>
          <StyledGrid item>
            <Typography color="#000">{t('signOff.nameTitle')}</Typography>
            <StyledTitles>{name}</StyledTitles>
          </StyledGrid>
        </Grid>
        {step === ProcessStep.IN_PROCESS && (
          <StyledGridItem container item xs={12} lg={6} direction="column">
            <WOSignOffManager
              isManager={isManager}
              handleSignIn={handleSignIn}
            />
          </StyledGridItem>
        )}
        {step === ProcessStep.DONE && (
          <Grid container item xs={12} lg={6} direction="column">
            <StyledSignedGridDone>
              {isEmpty(signature) ? (
                <StyledDiv>
                  <StyledDivImg />{' '}
                </StyledDiv>
              ) : null}
            </StyledSignedGridDone>
            <StyledSignedGrid>
              {!isEmpty(signature) ? (
                <StyledDiv>
                  <StyledImg
                    data-testid="signoff-signature"
                    src={signature}
                    alt="signoff-signature"
                  />
                </StyledDiv>
              ) : null}
              {signature && (
                <StyledColumnGrid>
                  <Typography sx={{ marginBottom: '5px' }} color="#000">
                    {t('signOff.signedOn')}
                  </Typography>
                  <DateContainer>
                    <StyledTitles>
                      {date?.split(',')[0]}, {date?.split(',')[1]}
                    </StyledTitles>
                  </DateContainer>
                </StyledColumnGrid>
              )}
            </StyledSignedGrid>
          </Grid>
        )}
      </Grid>
      <Grid item>
        <Typography sx={{ color: '#000', mb: '5px' }}>
          {t('signOff.notesTitle')}
        </Typography>
        <StyledTextField
          name="signOffNotes"
          multiline
          minRows={4}
          maxRows={4}
          variant="outlined"
          margin="dense"
          value={notes}
          placeholder={t('signOff.notesSectionInfo')}
          sx={{ width: '100%', margin: 0 }}
          inputProps={{
            sx: {
              color: '#bdbdbd',
            },
            'data-testid': 'readOnlyTextArea',
            readOnly: true,
          }}
        />
      </Grid>
    </StyledColumnGrid>
  );
};
